export var OPEN_SLIDE_MENU = 'OPEN_SLIDE_MENU';
export var OPEN_CHANNEL_VIEW = 'OPEN_CHANNEL_VIEW';
export var OPEN_VIDEO_VIEW = 'OPEN_VIDEO_VIEW';
export var CASHIER_MODAL_LOAD = "CASHIER_MODAL_LOAD";
export var CASHIER_PAYMENT_PAGE_LOAD = "CASHIER_PAYMENT_PAGE_LOAD";
export var CASHIER_PAYMENT_COMPLETE_PAGE_LOAD = "CASHIER_PAYMENT_COMPLETE_PAGE_LOAD";
